import React, { useContext, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Notification from "../../components/Notification";

const NotificationPage = () => {
  return (
    <Routes>
      <Route path="" element={<Notification isPage={true} />} />
    </Routes>
  );
};

NotificationPage.propTypes = {};

export default NotificationPage;
